import Intro from 'features/advance/screens/lightning/IntroPage/Intro';
import React from 'react';

const IntroPage = () => {
  return <Intro />;
};

export default IntroPage;
